import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TrustPipe } from '@frontend/sports/common/core/utils/dom';

import { BetslipOverAskAcceptTimeOutComponent } from './components/betslip-over-ask-accept-time-out.component';
import { BetslipOverAskPickLoadingComponent } from './components/betslip-over-ask-pick-loading.component';
import { BetslipOverAskRejectOfferDialogComponent } from './components/betslip-over-ask-reject-offer-dialog.component';

@NgModule({
    declarations: [BetslipOverAskAcceptTimeOutComponent, BetslipOverAskPickLoadingComponent, BetslipOverAskRejectOfferDialogComponent],
    imports: [CommonModule, TrustPipe],
    exports: [BetslipOverAskAcceptTimeOutComponent, BetslipOverAskPickLoadingComponent, BetslipOverAskRejectOfferDialogComponent],
    providers: [],
})
export class BetslipOverAskSharedModule {}
